import React, { useEffect, useState } from "react";
import ParentView from "../../Views/PrarentView/ParentView";
import AboutView from "../../Views/About/AboutView";
import { useNavigate, useParams, useLocation } from "react-router-dom";
const AboutScreen: React.FC<any> = (props: any) => {
  const [parentViewCheck, setParentViewCheck] = useState(true);

  const location = useLocation();
  useEffect(() => {
    const pathData = location.pathname;

    if (pathData.includes("nativeViews")) {
      props.setIsMobileView(true);
      setParentViewCheck(false);
    }
  }, [location]);

  return (
    <>
      {parentViewCheck ? (
        <ParentView>
          <AboutView parentViewCheck={parentViewCheck} />
        </ParentView>
      ) : (
        <AboutView parentViewCheck={parentViewCheck} />
      )}
    </>
  );
};

export default AboutScreen;
